export const APP_STORE_URL = "https://apps.apple.com/app/sport-exchange-100/id6758961035";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.sportex100.app";
